import React from 'react';

const SvgTime = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M7.75 0.00976562C3.46875 0.00976562 0 3.47852 0 7.75977C0 12.041 3.46875 15.5098 7.75 15.5098C12.0312 15.5098 15.5 12.041 15.5 7.75977C15.5 3.47852 12.0312 0.00976562 7.75 0.00976562ZM7.75 14.0098C4.29688 14.0098 1.5 11.2129 1.5 7.75977C1.5 4.30664 4.29688 1.50977 7.75 1.50977C11.2031 1.50977 14 4.30664 14 7.75977C14 11.2129 11.2031 14.0098 7.75 14.0098ZM9.68125 10.7473L7.02812 8.81914C6.93125 8.74727 6.875 8.63477 6.875 8.51602V3.38477C6.875 3.17852 7.04375 3.00977 7.25 3.00977H8.25C8.45625 3.00977 8.625 3.17852 8.625 3.38477V7.81289L10.7125 9.33164C10.8812 9.45352 10.9156 9.68789 10.7937 9.85664L10.2063 10.666C10.0844 10.8316 9.85 10.8691 9.68125 10.7473Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgTime;
